<template>
  <v-autocomplete
    v-model="internalValue"
    :items="items"
    :item-value="itemValue"
    :item-text="nombreRadiologo"
    clearable
    dense
    hide-details
    outlined
    class="pa-3"
    label="Radiólogo"
    :loading="loading"
    :disabled="disabled"
  >
    <template v-slot:selection="data">
      <div class="pa-1 d-flex flex-column">
        <div class="font-weight-medium">
          {{ data.item.nombre }} {{ data.item.apellido_paterno }} {{ data.item.apellido_materno }}
        </div>
        <div class="d-flex justify-space-between caption">
          <span class="red--text font-weight-bold">
            {{ data.item.per_interpretaciones_est_0.toFixed(1) }}% BI-RADS 0
          </span>
          &nbsp;&nbsp;
          <span class="green--text font-weight-bold">
            {{ data.item.per_interpretaciones_completadas.toFixed(1) }}% completadas
          </span>
        </div>
      </div>
    </template>

    <template v-slot:item="data">
      <v-list-item v-bind="data.attrs" v-on="data.on">
        <v-list-item-content>
          <v-list-item-title>
            {{ data.item.nombre }} {{ data.item.apellido_paterno }} {{ data.item.apellido_materno }}
          </v-list-item-title>

          <v-list-item-subtitle>
            {{ data.item.num_interpretaciones_realizadas }} realizadas,
            {{ data.item.num_interpretaciones_pendientes }} pendientes
          </v-list-item-subtitle>

          <!-- BI-RADS 0 -->
          <div class="d-flex align-center">
            <span class="mr-2 caption" style="min-width: 80px">BI-RADS 0</span>
            <v-progress-linear
              :value="data.item.per_interpretaciones_est_0"
              height="12"
              color="red"
              style="flex: 1"
              rounded
            >
              <template v-slot:default>
                <span class="black--text caption font-weight-bold">
                  {{ data.item.per_interpretaciones_est_0.toFixed(1) }}%
                </span>
              </template>
            </v-progress-linear>
          </div>

          <!-- Interpretaciones Completadas -->
          <div class="d-flex align-center mb-1">
            <span class="mr-2 caption" style="min-width: 80px">Completadas</span>
            <v-progress-linear
              :value="data.item.per_interpretaciones_completadas"
              height="12"
              color="green"
              style="flex: 1"
              rounded
            >
              <template v-slot:default>
                <span class="black--text caption font-weight-bold">
                  {{ data.item.per_interpretaciones_completadas.toFixed(1) }}%
                </span>
              </template>
            </v-progress-linear>
          </div>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'RadiologoSelect',
  props: {
    value: {
      type: [String, Number, Object, null],
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    itemValue: {
      type: String,
      default: 'id_usuario'
    },
    loading: {
      type:Boolean,
      default: false
    },
    disabled: {
      type:Boolean,
      default: false
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    nombreRadiologo: radiologo => `${ radiologo.nombre } ${ radiologo.apellido_paterno } ${ radiologo.apellido_materno }`,
  }
}
</script>
